module.exports = __webpack_public_path__ + "abd3bf9aa1634080189acb18b54ebf12.png";